import * as xlsx from "xlsx";

const $inject = ['$q', '$scope', '$routeParams', 'Upload', 'dataService', 'lbaLeafletMapService', '$window', '$timeout'];

function dateTimeString(int) {
  if (String(int).length === 1) return '0' + int;

  return String(int);
}

const lbaFileUploaderCtrl = function ($q, $scope, $routeParams, Upload, dataService, lbaLeafletMapService, $window, $timeout) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

  vm.data = _.get(dataService.data.activeItem, dataLookUp);
  vm.importFile = importFile;
  vm.blobUrl = blobUrl;
  vm.progressPercentage = 0;
  vm.uploadSuccess = false;
  vm.uploadFailure = false;
  vm.uploading = false;
  let zeroAddresses = [];
  vm.filename = '';
  vm.errorText = '';
  vm.deleteImage = deleteImage;

  // Processing monitor state (SignalR-based post-upload tracking)
  vm.processingStatus = null; // null | 'waiting' | 'success' | 'error'
  vm.processingMessage = '';
  let signalRConnection = null;

  $scope.$on('$destroy', function () {
    if (signalRConnection) {
      signalRConnection.stop();
      signalRConnection = null;
    }
  });
  
  vm.pointsOfInterestColumns = [
    {
      name: 'DebtorIdentifier',
      dataAt: 'DebtorIdentifier',
    },
    {
      name: 'Title',
      dataAt: 'Title',
    },
    {
      name: 'Description',
      dataAt: 'Description',
    },
    {
      name: 'Address',
      dataAt: 'Address',
    },
    {
      name: 'Latitude',
      dataAt: 'Latitude',
    },
    {
      name: 'Longitude',
      dataAt: 'Longitude',
    },
  ];

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });

  function getPosition(address, i) {
    var defer = $q.defer();
    lbaLeafletMapService.getPosByAddress(address, i)
      .then((data) => {
        defer.resolve(data);
      })
      .catch((status) => {
        if (status == 'ZERO_RESULTS') {
          defer.resolve();
          zeroAddresses.push(i + 2);
          console.log(`Problem recognising address for row ${i + 2} -`, address);
        }
        else {
          defer.reject(status);
          console.log('Error getting position', status);
        }    
      });
    return defer.promise;
  }

  vm.upload = function (file) {
    vm.uploadFailure = false;
    vm.uploadSuccess = false;
    vm.uploading = true;
    vm.processingStatus = null;
    vm.processingMessage = '';

    if (!file) {
      vm.uploading = false;
      vm.uploadFailure = true;
      vm.errorText = 'Please select a file to upload.';
      return false;
    }

    Upload.upload({
      url: `${endPointUrl}/api/Upload/${vm.settings.fileContainer}?filename=${vm.filename}`,
      data: { file: file }
    }).then(function (resp) {
      vm.uploading = false;
      const result = resp.data;

      // Handle structured response { IsSuccess, Message, FileName, Extension }
      if (result && typeof result.IsSuccess !== 'undefined') {
        if (!result.IsSuccess) {
          vm.uploadSuccess = false;
          vm.uploadFailure = true;
          vm.errorText = result.Message || 'File upload failed.';
          return;
        }
        const uploadedFileName = result.FileName || vm.filename;
        vm.uploadSuccess = true;
        if (!vm.settings.excludeFromPost) {
          vm.data = uploadedFileName;
        } else {
          vm.filename = uploadedFileName;
        }
        if (vm.settings.useProcessingMonitor) {
          startSignalRMonitor(uploadedFileName);
        }
      } else {
        // Legacy plain string/data response
        vm.uploadSuccess = true;
        if (!vm.settings.excludeFromPost) {
          vm.data = result;
        } else {
          vm.filename = result;
        }
      }
    }, function (error) {
      vm.uploading = false;
      vm.uploadSuccess = false;
      vm.uploadFailure = true;
      const serverMsg = error.data && error.data.Message ? error.data.Message : null;
      vm.errorText = serverMsg || 'File upload failed.';
      console.log('Error status: ' + error.status);
    }, function (evt) {
      vm.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
    });
  };

  function startSignalRMonitor(uploadedFileName) {
    vm.processingStatus = 'waiting';
    vm.processingMessage = 'File is in the processing queue. Please wait or check back shortly to verify the approvers.';

    const lastDot = uploadedFileName.lastIndexOf('.');
    const processedFileName = lastDot !== -1
      ? uploadedFileName.substring(0, lastDot) + '_Processed' + uploadedFileName.substring(lastDot)
      : uploadedFileName + '_Processed';

    const container = vm.settings.processingContainer || 'debtorapprover-uploads';
    const hubUrl = endPointUrl + '/fileProcessingHub';

    // Dynamically load a script tag only once (idempotent).
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        if (document.querySelector('script[src="' + src + '"]')) { resolve(); return; }
        var s = document.createElement('script');
        s.src = src;
        s.onload = resolve;
        s.onerror = function () { reject(new Error('Failed to load ' + src)); };
        document.head.appendChild(s);
      });
    }

    // Ensure the classic ASP.NET SignalR 2.x jQuery client is available.
    // Scripts are served from resourceBaseUrl (blob storage in production, '/' locally).
    function ensureSignalRLoaded() {
      var base = (typeof window.resourceBaseUrl === 'string' && window.resourceBaseUrl !== '')
        ? window.resourceBaseUrl
        : '';
      var p = Promise.resolve();
      if (typeof window.jQuery === 'undefined') {
        p = p.then(function () { return loadScript(base + '/jquery.min.js'); });
      }
      return p.then(function () {
        if (typeof window.jQuery.hubConnection !== 'function') {
          return loadScript(base + '/signalr.min.js');
        }
      });
    }

    ensureSignalRLoaded()
      .then(function () { connectAndSubscribe(); })
      .catch(function () {
        $scope.$apply(function () {
          vm.processingStatus = 'error';
          vm.processingMessage = 'SignalR client could not be loaded. Cannot monitor processing status.';
        });
      });

    function connectAndSubscribe() {
      const connection = window.jQuery.hubConnection(hubUrl, { useDefaultPath: false });
      const hub = connection.createHubProxy('fileProcessingHub');
      signalRConnection = connection;

      // Server calls Clients.Caller.FileStatusUpdate(update) — event name is camelCase on client
      hub.on('fileStatusUpdate', function (update) {
        $scope.$apply(function () {
          const isProcessed = update.Status === 1 || update.Status === 'Processed';
          const isFailed    = update.Status === 2 || update.Status === 'Failed';
          const isInQueue   = update.Status === 0 || update.Status === 'InQueue';

          if (isProcessed) {
            vm.processingStatus = 'success';
            vm.processingMessage = 'File processed successfully. Refreshing page...';
            vm.uploadSuccess = true;
            connection.stop();
            signalRConnection = null;
            $timeout(function () { $window.location.reload(); }, 2000);
          } else if (isFailed) {
            vm.processingStatus = 'error';
            vm.processingMessage = update.Message ||
              'Some issue while processing the file. Please check the email on the agent email address.';
            connection.stop();
            signalRConnection = null;
          } else if (isInQueue) {
            // still waiting
          }
        });
      });

      connection.start()
        .done(function () {
          hub.invoke('SubscribeToFileProcessing', {
            FileName: uploadedFileName,
            ProcessedFileName: processedFileName,
            Container: container
          }).fail(function () {
            $scope.$apply(function () {
              vm.processingStatus = 'error';
              vm.processingMessage = 'Unable to subscribe to file processing status.';
            });
          });
        })
        .fail(function () {
          $scope.$apply(function () {
            vm.processingStatus = 'error';
            vm.processingMessage = 'Unable to connect to file processing service.';
          });
        });
    }
  }

  function importFile(file) {
    vm.uploading = false;
    vm.uploadSuccess = false;
    vm.uploadFailure = false;

    if (!file) {
      return;
    }

    let fileExtension = file.name.substr(file.name.lastIndexOf('.'));
    let fileName;

    if (vm.settings.fileNameFormat) {
      let fileNameDate = new Date();

      fileName = dateTimeString(fileNameDate.getFullYear());
      fileName += dateTimeString(fileNameDate.getMonth() + 1);
      fileName += dateTimeString(fileNameDate.getDate()) + '_';
      fileName += dateTimeString(fileNameDate.getHours());
      fileName += dateTimeString(fileNameDate.getMinutes());

    } else {
      fileName = new Date() + '';
      fileName = fileName.replace(/[^\/\d]/g, '');
    }

    if (vm.settings.fileNamePrefixProperty) {
      fileName = dataService.data.activeItem[vm.settings.fileNamePrefixProperty] + '_' + fileName;
    }

    if (vm.settings.fileNameSuffix) {
      fileName = fileName + vm.settings.fileNameSuffix;
    }

    fileName += fileExtension;
    vm.filename = fileName;

    if (vm.settings.dataAt == 'PointsOfInterestFile') {
      var reader = new FileReader();
      let output = [];
      reader.onload = function (e) {
        vm.uploading = true;
        zeroAddresses = [];
        try {
          var data = e.target.result;
          var wb = xlsx.read(data, {
            type: "binary",
          });
          var getPositionPromises = [];
          wb.SheetNames.forEach((sheetName) => {
            output = xlsx.utils
              .sheet_to_json(wb.Sheets[sheetName])
              .map((item, i) => {
                const obj = {};
                vm.pointsOfInterestColumns.forEach((col) => {
                  if (col.name == 'Latitude' && item[col.name] == null) {
                    var promise = getPosition(item['Address'], i).then((position) => {
                      _.set(obj, 'Latitude', position ? position.lat : null);
                      _.set(obj, 'Longitude', position ? position.long : null);
                    });
                    getPositionPromises.push(promise);
                  } else {
                    _.set(obj, col.dataAt, item[col.name] || null);
                  }
                });
                return obj;
              });
          });

          $q.all(getPositionPromises).then(() => {
            if (zeroAddresses.length > 0) {
              vm.uploading = false;
              vm.uploadFailure = true;
              vm.errorText = zeroAddresses.length > 1 ? `Unrecognised addresses. Please check the following rows: ${zeroAddresses}` 
              : `Unrecognised address. Please check row ${zeroAddresses}`;
            } else {
              var ws = xlsx.utils.json_to_sheet(output);
              const wb = xlsx.utils.book_new();
              xlsx.utils.book_append_sheet(wb, ws, 'points-of-interest');
              var content = xlsx.write(wb, { type: 'array' });
              var newFile = new File([content], vm.filename, { type: "plain/xlsx" });
              vm.upload(newFile);
              }
          }, function (error) {
            vm.uploading = false;
            vm.uploadFailure = true;
            console.log(error);
          });
        } catch (e) {
          console.warn(e);
        }
      }

      reader.onerror = function (ex) {
        console.warn(ex);
      };

      reader.readAsBinaryString(file);
    } else {
      vm.upload(file);
    }
  }

  function deleteImage() {
    vm.data = null;
  }
};

lbaFileUploaderCtrl.$inject = $inject;

export default lbaFileUploaderCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaFileUploader/lbaFileUploaderCtrl.js